import React, { useState } from "react";
import { Label } from "reactstrap";
import Typeahead from "../../../CommonElements/TypeAhead";
import { H3 } from "../../../AbstractElements";
import { Addtoleads } from "../../../Constant";
import {
  postClientUrlWithToken,
  postDataWithToken,
} from "../../../Utils/restUtils";
import { storeLead } from "../../../CommonURL";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

function AddToLead({
  EnquiryDetails,
  userOption,
  staffOptions,
  handleModal,
  selectedStaff,
}) {
  const [loading, setLoading] = useState(false);
  const [remark, setRemarks] = useState("");
  const [selectedUser, setSelectedUser] = useState(selectedStaff);
  const navigate = useNavigate();
  const authState = useSelector((state) => state.auth);
 
  const handleAddToLeads = async () => {
    const postRequest = {
      name: EnquiryDetails.name,
      phone: EnquiryDetails.phone,
      email: EnquiryDetails.email,
      industry_type_id:EnquiryDetails.industry_type_id,
      stage: "prospect",
      enquiry_id: EnquiryDetails?.id,
      status: EnquiryDetails?.status,
      assigned_to: selectedUser?.value,
      remarks: remark,
    };

    setLoading(true);

    const addCustomerResponse = await postDataWithToken(storeLead, postRequest);
    if (addCustomerResponse.status === 200) {
      if (addCustomerResponse.data.status === true) {
        handleModal();

        toast.success(addCustomerResponse.data.message);
        navigate(`${process.env.PUBLIC_URL}/lead-manage/leads`);
      } else {
        toast.error(addCustomerResponse.data.message);
        setLoading(false);
      }
    } else if (
      addCustomerResponse.status >= 400 &&
      addCustomerResponse.status <= 405
    ) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (
      addCustomerResponse.status >= 500 &&
      addCustomerResponse.status <= 505
    ) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
    setLoading(false);
  };
  return (
    <div>
      {loading && <Transparentspinner />}
      <H3>{Addtoleads}</H3>

      <div>
        <div style={{ width: "100%" }}>
          <label className="form-label text-muted small">Enquiry Status</label>
          <div className="d-flex gap-2 align-items-center">
            <select
              className="form-select"
              value={EnquiryDetails?.status}
              onMouseDown={(e) => e.preventDefault()}
            >
              <option value="sda">{EnquiryDetails?.status}</option>
            </select>

            <span className={`badge-${EnquiryDetails?.status}`}>
              {EnquiryDetails?.status}
            </span>
          </div>
          <div className="mb-3">
            <label className="form-label text-muted small">Assigned To</label>
            <Typeahead
              options={staffOptions}
              value={selectedUser}
              onChange={(value) => setSelectedUser(value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label text-muted small">Remarks</label>
            <textarea
              className="form-control"
              name="remarks"
              id="remarks"
              rows="4"
              placeholder="Enter your remarks..."
              value={remark}
              onChange={(e) => {
                setRemarks(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <div>
            <button onClick={handleModal} className="btn btn-">
              Cancel
            </button>
            <button
              onClick={() => handleAddToLeads()}
              className="btn btn-primary mx-2"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddToLead;
